import { Model } from 'vue-models'
import DateTime from './types/DateTime'
import TextField from './types/TextField'
import CarrierModel from './carrier'
import ProjectModel from './project'
import Shipment from './shipment'

export default class TrackingRequest extends Model {
  static defaults () {
    return {
      name: 'tracking request',
      basePath: 'tracking-requests',
      computed: {
        archivable () {
          if (!this.cancellable) { return false }
          return ['new', 'pending_archiving', 'archived', 'pending_cancelling', 'cancelled'].indexOf(this.status) < 0
        },
        cancellable () {
          return ['new', 'pending_archiving', 'pending_cancelling', 'cancelled'].indexOf(this.status) < 0
        }
      }
    }
  }
  static schema () {
    return {
      id: { type: Number },
      carrier: { type: CarrierModel },
      carrier_id: { type: Number },
      project: { type: ProjectModel },
      project_id: { type: Number },
      code_type: { type: TextField },
      code_value: { type: TextField },
      client_code: { type: TextField },
      contractual_eta_pod: { type: DateTime },
      contractual_eta_dlv: { type: DateTime },
      status: { type: TextField },
      shipments_count: { type: Number },
      shipments_health: { type: TextField },
      shipments: { type: Array, items: { type: Shipment } },
      last_update: { type: DateTime },
      created_at: { type: DateTime },
      modified_at: { type: DateTime },
      warnings: { type: Array, items: { type: TextField } },
      alerts: { type: Array, items: { type: TextField } }
    }
  }
  static STATUS = {
    invalid: 'Invalid',
    new: 'New',
    ongoing: 'On going',
    pending_archiving: 'Pending of archiving',
    archived: 'Archived',
    pending_cancelling: 'Pending of cancelling',
    cancelled: 'Cancelled'
  }
  static STATUS_FILTER = {
    invalid: 'Invalid',
    new: 'New',
    ongoing: 'On going',
    archived: 'Archived',
    cancelled: 'Cancelled'
  }
  static SHIPMENTS_HEALTH = {
    ontrack: 'On track',
    delayed: 'Later than expected',
    alerted: 'Attention required'
  }
}



// WEBPACK FOOTER //
// ./src/models/trackingRequest.js